import { colors } from '../../style';

export const variants = {
  gray600: {
    fill: colors.gray600,
  },
  white: {
    fill: colors.white,
  },
};

export const sizes = {
  xs: {
    height: '20px',
  },
  sm: {
    height: '30px',
  },
};
